import React from "react";
import MVPTableTailwind from "../admin/MVPTableTailwind";
import TailwindPageWrapper from "../generic/TailwindPageWrapper";

function PublicMVPTable() {
  return (
    <TailwindPageWrapper>
      <div className="-mt-24">
        <MVPTableTailwind />
      </div>
    </TailwindPageWrapper>
  );
}

export default PublicMVPTable;

